import Vue from 'vue'
import excel from 'vue-excel-export'
 
Vue.use(excel)